import React, { useRef, useEffect, useState } from 'react'
import Menu from './menu/Menu'
import TableView from '../shared/TableView'
import updateData from '../utils/update'
import { useTableUtils } from '../../../shared/contexts/TableUtilsContext'
import { useColumnSelection } from '../../../shared/contexts/ColumnSelectionContext'
import { useData } from '../../../shared/contexts/DataContext'
import { useScrapeDate } from '../../../shared/contexts/ScrapeDateContext'
import getUniqueCategories from '../../visualizations/single_visualization/utils/getUniqueCategories'
import config from '../../../config/config'
import ClearButtons from '../../../shared/search/ClearButton'
import { useFilterSearch } from '../../../shared/search/useFilterSearch'
import ExportMenu from '../selected_data/export_menu/ExportMenu.js'
import { slashDateToStringDate, formatSlashDateToISO } from '../../data/shared/table/format.js'

// Function based component that displays the search bar and table with all the datapoints that can be selected
function DataSelect() {

  const { tableUtils, setTableUtils } = useTableUtils()

  const {
    hasActiveFilters,
    hasActiveSearch,
    clearFilters,
    clearSearch
  } = useFilterSearch(tableUtils, setTableUtils, "main")

  // We need to keep a reference of the columns
  // Used in ranking the data when applying a search
  const { columnSelection } = useColumnSelection()
  let columnsRef = useRef(columnSelection)
  let queryRef = useRef(tableUtils.search)

  // We update the columns if a new search is initialized
  if (tableUtils.search !== queryRef.current) {
    columnsRef.current = columnSelection
    queryRef.current = tableUtils.search
  }

  const scrapeDate = useScrapeDate()
  const formattedDate = slashDateToStringDate(formatSlashDateToISO(scrapeDate));

  // Update the data based on the search, filters and sorters
  // The search, filters and sorters are all located in the tableUtils context
  // Also rank the data based on the current selected columns
  const allData = useData()
  const updatedData = updateData(allData, tableUtils, columnsRef.current)

  // Handler that is called after the filters and sorters in the menu are applied
  const menuUpdate = (filters, sorters) => {
    // Update the filters and sorters context with the ones applied in the menu
    setTableUtils({
      ...tableUtils,
      filters: filters,
      sorters: sorters,
    })
  }

  // Store the categories of each variable (which are used in the filter options)
  const [categories, setCategories] = useState(null)
  useEffect(() => {
    setCategories(getUniqueCategories(allData))
  }, [allData])

  // Get the number of rows in total and after filters are applied
  const totalRows = allData.length
  const filteredRows = updatedData.length

  return (
    <>
      <div tour="step-data-select" className="med-content-container">


        {/* <ToggleButtons
          clickFunction1={ButtonFunctions.OpenHuman}
          clickFunction2={ButtonFunctions.OpenOrphan}
        /> */}

        <h1 className="med-header">
          {config.data.name} {' '}
          <span> Last updated on {formattedDate}</span>
          {filteredRows !== totalRows ? (
            <span className="selected-data-count">
              {` - ${filteredRows} out of ${totalRows} ${config.data.plural} displayed`}
            </span>
          ) : (
            <span>
              {` - ${totalRows} ${config.data.plural} available`}
            </span>
          )}
        </h1>
        <ExportMenu selectedData={updatedData} text="Export all shown" />

        <Menu
          filters={tableUtils.filters}
          sorters={tableUtils.sorters}
          update={menuUpdate}
          categories={categories}
        />

        <hr className="med-top-separator" />
        <ClearButtons
          tableUtils={tableUtils}
          setTableUtils={setTableUtils}
          dataType="main"
          showWhenNoResults={true}
          filteredRows={filteredRows}
        />
        <TableView
          data={updatedData}
          sorters={tableUtils.sorters}
          setSorters={(e) => setTableUtils({ ...tableUtils, sorters: e })}
          select={true}
          text="No data to display, please check your search or filters."
          dataType={"main"}
        />
        {/* <hr className="med-top-separator" />
        <h3>
          *: The source document was uploaded before the introduction of this variable
        </h3> */}
      </div>
    </>
  )
}

export default DataSelect